// setHeaderHeight()

// window.matchMedia('(max-width: 798px)').addEventListener('change', setHeaderHeight());

// function setHeaderHeight() {
//     document.documentElement.style.setProperty('--header-height', `${.offsetHeight}px`);
// }

document.querySelectorAll('.button--step').forEach(btn => {
    const id = btn.dataset.blockNum
    const parent = btn.closest('.quiz-item')
    const radiosReq = parent.querySelectorAll('[type="radio"][required]')
    const inputsReq = parent.querySelectorAll('[type="text"][required], [type="email"][required]');
    const tabHiddenInput = parent.querySelector('.tab-item-input')

    btn.addEventListener('click', function() {
        var stoppage = 0;

        if ( inputsReq.length > 0 && btn.dataset.direction == 'next' ) {
            const inputReq = Array.from(inputsReq).filter(input => input.value != '' )

            if (inputReq.length == 0) {
                stoppage = 1;
                parent.classList.add('error-state')
            }
        } else if (radiosReq.length > 0 && btn.dataset.direction == 'next' ) {
            const checkedRadio = Array.from(radiosReq).filter(input => input.checked )

            if (checkedRadio.length == 0) {
                stoppage = 1;
                parent.classList.add('error-state')
            }
        }

        if (id && stoppage != 1) {
    
            document.querySelectorAll('.quiz-item').forEach(q => {
                q.classList.remove('active')
            })

            document.querySelector(`.quiz-item[data-id="quiz-item-${id}"]`)?.classList.add('active')
        }
    })

    inputsReq.forEach(input => {
        input.addEventListener('input', function() {
            parent.classList.remove('error-state')
            tabHiddenInput.value = input.value
            
            tabHiddenInput.dataset.answerHandle = handleize(input.value)

            if (input.getAttribute('name') == 'name' && input.value != '' && document.querySelectorAll('.name-result').length > 0) {

                document.querySelectorAll('.name-result').forEach(resultHeading => {
                    resultHeading.textContent = input.value.trim()
                })
            }
        })
    })

    radiosReq.forEach(r => {
        r.addEventListener('change', function() {
            parent.classList.remove('error-state')
            if (r.checked) {
                tabHiddenInput.value = r.value
                tabHiddenInput.dataset.answerHandle = handleize(r.value)
            }
        })
    })
})

document.querySelector('.button--step-last').addEventListener('click', function() {
    var stoppage = 0;
    const childParent = this.closest('.quiz-item')

    const inputsReq = childParent.querySelectorAll('[type="text"][required], [type="email"][required]');
    const radiosReq = childParent.querySelectorAll('[type="radio"][required]')

    if ( inputsReq.length > 0 ) {
        const inputReq = Array.from(inputsReq).filter(input => input.value != '' )

        if (inputReq.length == 0) {
            stoppage = 1;
            childParent.classList.add('error-state')
        }
    } else if (radiosReq.length > 0) {
        const checkedRadio = Array.from(radiosReq).filter(input => input.checked )

        if (checkedRadio.length == 0) {
            stoppage = 1;
            childParent.classList.add('error-state')
        }
    }

    if (stoppage == 1) return;


    const parent = this.closest('.quiz-parent-container');

    const tabHiddenInputs = parent.querySelectorAll('.quiz-item .tab-item-input');

    const answersObj = {};

    tabHiddenInputs.forEach((input, index) => {
        if (input.value.trim() !== "") {

            answersObj[`answer_${index + 1}`] = handleize(input.getAttribute('data-answer-handle')).trim();
        }
    });

    console.log(answersObj); // Log the resulting object

    parent.querySelectorAll('.result-item').forEach(result => {
        const assign2 = result.dataset.answer2;
        const assign3 = result.dataset.answer3;

        // Check if assign2 and assign3 match exactly with answer_3 or answer_4
        if (
            (assign2 === answersObj.answer_3 || assign2 === answersObj.answer_4) &&
            (assign3 === answersObj.answer_3 || assign3 === answersObj.answer_4)
        ) {
            parent.querySelectorAll('.result-item').forEach(rr=> {
                rr.classList.remove('active')
            })

            result.classList.add('active')
        }
    });

    handleAnalytics(parent)
});

function handleize(value) {
    return value
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
        .replace(/^-+|-+$/g, '');   // Remove leading or trailing hyphens
}

function handleAnalytics(container) {
    const quizContainers = container.querySelectorAll('.quiz-item');
    const resultContainer = container.querySelector('.result-item.active'); // Fixed to use querySelector for single active container
    const recomms = resultContainer.querySelectorAll('[data-product-name]');
    const obj = {};

    // Collect all `data-product-name` values and join them as a comma-separated string
    const recommendations = Array.from(recomms)
        .map(recomm => recomm.dataset.productName)
        .join(', ');

    obj['quiz_recommendations'] = recommendations;

    Array.from(quizContainers).forEach((q, index) => {
        const loopIndex = index + 1;
        const question = q.dataset.question;
        const answer = q.querySelector('.tab-item-input').value;

        obj[`quiz_${loopIndex}_question`] = question;
        obj[`quiz_${loopIndex}_answer`] = answer;
    });

    gtag("event", "quiz_taken", obj);
}